import { isWindowsApp } from "../../platform";

export const nativeExamFlowEnabled = isWindowsApp
  && process.env.REACT_APP_NATIVE_EXAM_FLOW_V2 === "true";

export const correctionAvailability = (exercises = []) => {
  const total = exercises.reduce((sum, item) => sum + Number(item.correction_items_total || 0), 0);
  const available = exercises.reduce((sum, item) => sum + Number(item.correction_items || 0), 0);
  const unknown = exercises.some((item) => !item.correction_status);
  if (unknown) return { status: "unknown", available, total };
  if (total > 0 && available === total) return { status: "complete", available, total };
  if (available > 0) return { status: "partial", available, total };
  return { status: "absent", available, total };
};

const diagnosticReference = () => {
  const random = window.crypto?.randomUUID?.().replace(/-/g, "").slice(0, 8).toUpperCase();
  return `GEN-${random || Date.now().toString(36).toUpperCase()}`;
};

export const describeGenerationError = (error) => {
  const status = error?.response?.status;
  const serverDetail = typeof error?.response?.data?.detail === "string"
    ? error.response.data.detail.trim()
    : "";
  if (!error?.response) {
    return {
      message: "La réponse du serveur n’a pas été reçue. La tentative peut néanmoins avoir abouti.",
      action: "retry",
      actionLabel: "Vérifier et réessayer avec la même référence",
      uncertain: true,
    };
  }
  if (status === 400) return { message: serverDetail || "Certaines informations de l’épreuve sont invalides.", action: "modify", actionLabel: "Corriger les informations", uncertain: false };
  if (status === 403) return { message: "Votre compte ne permet pas cette génération. Contactez l’assistance si cette situation est inattendue.", action: "support", actionLabel: "Contacter l’assistance", uncertain: false };
  if (status === 409 && serverDetail.includes("déjà en cours")) return { message: "Cette génération est déjà en cours. Vous pouvez vérifier son résultat sans créer une nouvelle tentative.", action: "retry", actionLabel: "Vérifier avec la même référence", uncertain: true };
  if (status === 503) return { message: "Le service de génération est temporairement indisponible.", action: "retry", actionLabel: "Réessayer avec la même référence", uncertain: true };
  if (status >= 500) return { message: "Le serveur n’a pas pu produire les documents.", action: "retry", actionLabel: "Réessayer avec la même référence", uncertain: false };
  return {
    message: "Une erreur inattendue a empêché la génération.",
    action: "support",
    actionLabel: "Contacter l’assistance",
    uncertain: false,
    diagnosticReference: diagnosticReference(),
  };
};
